/*
 * MDB shim for Modal
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/CreateModal.jsx
 * - src/Components/Custom/InformationChangeModal.jsx
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Activities/activitiesModal.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Faxes/faxes.jsx
 * - src/Seating/InventoryProduct/inventoryProductTable.jsx
 * - src/Seating/Orders/RecurringOrders.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/liaisonModal.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/deliveryAcknowledgements.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Settings/manualDocumentBuilder.jsx
 * - src/Seating/Settings/productTypes.jsx
 * - src/Seating/Settings/reasons.jsx
 * - src/Seating/Settings/trainingLink.jsx
 * - src/Seating/Settings/vendor.jsx
 * - src/Seating/Users/thirdPartyUserList.jsx
 */

import MUIDialog from "@mui/material/Dialog";

export default function Modal({ children, isOpen, toggle, onClose, maxWidth, fullWidth, ...rest }) {
    function handleClose(...args) {
        onClose?.(...args);
        toggle?.(...args);
    }

    return (
        <MUIDialog open={Boolean(isOpen)} onClose={handleClose} fullWidth={fullWidth} maxWidth={maxWidth} {...rest}>
            {children}
        </MUIDialog>
    );
}
